import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Cookies from "js-cookie";
import NewsletterSignupFormName from "./forms/newsletterName";
import NewsletterSignupFormNoName from "./forms/newsletterNoName";

import "../components/styles/newsletterSignup.scss";

function determineVariant() {
  // Logic to decide variant (e.g., based on a random number, user segment, etc.)
  if (Math.random() < 0.5) {
    return "A";
  } else {
    return "B";
  }
}


export default function NewsletterSignup() {

  let variant = determineVariant();

  const muNewsletter = Cookies.get("_muNewsletter");

  const [show, setShow] = useState(false);
  const handleOpen = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    Cookies.set("_muNewsletter", "Closed", { expires: 7 });
  };

  const handleSignup = () => {
    setShow(false);
    Cookies.set("_muNewsletter", "Registered", { expires: 36500 });
  };

  const [result, setResult] = useState(null);

  useEffect(() => {
    const flipCoin = () => {
      const randomValue = Math.random();
      const outcome = randomValue < 0.5 ? 'A' : 'B';

      // Simulate flip duration 
      setTimeout(() => {
        setResult(outcome);
      }, 10);
    };

    flipCoin();

    const timer = setTimeout(() => {
      setShow(true);
    }, 10000);
    
    // clear timer if the component unmount
    return () => clearTimeout(timer);
  }, []);

  if (muNewsletter) {
    return null;
  } else {
    return (
      <div>
        <Modal
          show={show}
          onHide={handleClose}
          onClose={handleClose}
          backdrop="static"
          keyboard={false}
          size="xl"
          centered
          id="newsletter"
        >
          <Container fluid className="px-0">
            <Row className="align-items-center">
              <Col xs={12} className="d-flex d-xl-none">
                <Modal.Header closeButton className="p-0" />
                <img
                  src="https://web-cdn.meridianuniversity.edu/site-content-images/newsletter-signup-tablet-2024.webp"
                  className="img-fluid d-none d-lg-block d-xl-none"
                  alt="A Lighthouse on a Stormy Shore"
                  style={{ marginTop: -1 }}
                />
                <img
                  src="https://web-cdn.meridianuniversity.edu/site-content-images/newsletter-signup-mobile-2024.webp"
                  className="img-fluid d-lg-none"
                  alt="A Lighthouse on a Stormy Shore"
                  style={{ marginTop: -1 }}
                />
              </Col>
              <Col xs={12} xl={7}>
                <Modal.Dialog>
                  <Modal.Body className="p-4 px-xl-5 py-xl-2">
                    <h2 className="mb-3">
                      Stay Updated on Content and Programs
                    </h2>
                    <p className="mb-0">
                      Sign up for Meridian’s email newsletter to hear about the
                      latest podcast episodes, online courses, and upcoming
                      global events.
                    </p>
                    { 
                      variant === "A" ? <NewsletterSignupFormName
                      submitCampaignID="701UZ000005Ug3rYAC"
                      submitType="contact"
                      onClose={handleSignup}
                      form={result}
                    />
                    :
                    <NewsletterSignupFormNoName
                      submitCampaignID="701UZ000005Ug3rYAC"
                      submitType="contact"
                      onClose={handleSignup}
                    />
                    } 
                    
                    <p className="small mb-0">
                        We don’t email frequently and you can always
                        unsubscribe. By continuing, you are agreeing to
                        Meridian’s <a href="/privacy">Privacy Policy</a>.
                    </p>
                  </Modal.Body>
                </Modal.Dialog>
              </Col>
              <Col xl={5} className="d-none d-xl-flex">
                <Modal.Header closeButton className="p-0" />
                <img
                  src="https://web-cdn.meridianuniversity.edu/site-content-images/newsletter-signup-desktop-2024.webp"
                  className="img-fluid"
                  alt="A Lighthouse on a Stormy Shore"
                  style={{ marginTop: -1 }}
                />
              </Col>
            </Row>
          </Container>
        </Modal>
      </div>
    );
  }
}
